"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Lifecycle = (function () {
    function Lifecycle() {
    }
    Lifecycle.prototype.onExiting = function (handler) {
        return false;
    };
    Lifecycle.prototype.onResuming = function (handler) {
        return false;
    };
    Lifecycle.prototype.onSuspending = function (handler) {
        return false;
    };
    Lifecycle.prototype.onFullscreenChanged = function (handler) {
        return false;
    };
    Lifecycle.prototype.setFullscreen = function (isFullscreen) {
        return false;
    };
    Lifecycle.prototype.openExternalUrl = function (url) {
        return false;
    };
    return Lifecycle;
}());
exports.Lifecycle = Lifecycle;
